// src/app/layout/CoreSidebar.tsx
import { CoreNavList } from './CoreNavList';

// Desktop-only nav surface (>= lg). Item rendering lives in
// CoreNavList, shared with CoreMobileNavDrawer below lg. Same
// deliberate omission as Step 1's Sidebar: no user/logout block at
// its foot — "User Area" is its own region, rendered in
// CoreHeader/UserArea.tsx instead of duplicated here.
export function CoreSidebar() {
  return (
  <aside className="vania-command-sidebar vania-shell-sidebar hidden xl:flex">
      <div className="vania-command-brand vania-shell-brand">
        <span className="vania-shell-brand-mark">
          V
        </span>
      </div>

      <CoreNavList />
    </aside>
  );
}
